import React from "react";
import get from "lodash/get";
import PropTypes from "prop-types";
import * as constants from "@redbubble/design-system/react/constants";
import Box from "@redbubble/design-system/react/Box";
import Grid from "@redbubble/design-system/react/Grid";
import MediaCard from "@redbubble/design-system/react/MediaCard";
import Text from "@redbubble/design-system/react/Text";
import Heart from "../../../../Lists/Heart";
import ProductPrice from "../../../../ProductPrice";
import styles from "../../RangePage.scss";
import { listManagerShape } from "../../../../Lists";

const AvailableProductsSection = ({
  availableProducts,
  availableProductsLoading,
  isLarge,
  isLoggedIn,
  listManager,
  locale,
  openLoginSignupModal,
}) => {
  if (
    !availableProductsLoading &&
    Array.isArray(availableProducts) &&
    availableProducts.length <= 0
  )
    return null;

  const placeholders = new Array(6).fill(true).map((_, id) => ({
    id,
    description: "",
    productTypeId: "",
    price: {
      amount: 0,
      currency: "USD",
    },
    previewSet: {
      previews: [
        {
          previewTypeId: 0,
          url: "",
        },
      ],
    },
    productPageUrls: {
      fallbackUrl: "",
    },
  }));

  return (
    <Box
      className={styles.availableProductsContainer}
      paddingBottom="xl"
      size={constants.MEDIUM}
      data-testid="available-products-section"
    >
      <Box padding="s">
        <Grid columns={isLarge ? 5 : 2}>
          {(availableProductsLoading ? placeholders : availableProducts).map(
            (product) => {
              return (
                <MediaCard
                  transparent
                  key={get(product, "id")}
                  data-testid="available-product"
                  loading={availableProductsLoading}
                  imageSrc={get(product, "previewSet.previews[0].url")}
                  imageRatio={constants.RATIO_SQUARE}
                  title={
                    availableProductsLoading
                      ? "Title"
                      : get(product, "description")
                  }
                  href={get(product, "productPageUrls.fallbackUrl")}
                  primaryActionSlot={
                    availableProductsLoading ? null : (
                      <Heart
                        item={{
                          entityType: "INVENTORY_ITEM",
                          entityId: get(product, "id"),
                          preview: get(product, "previewSet.previews[0].url"),
                        }}
                        isLoggedIn={isLoggedIn}
                        locale={locale}
                        listManager={listManager}
                        openLoginSignupModal={openLoginSignupModal}
                      />
                    )
                  }
                >
                  {availableProductsLoading ? (
                    <Text loading>Product price</Text>
                  ) : (
                    <ProductPrice inventoryItem={product} />
                  )}
                </MediaCard>
              );
            }
          )}
        </Grid>
      </Box>
    </Box>
  );
};

AvailableProductsSection.propTypes = {
  availableProducts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      productTypeId: PropTypes.string.isRequired,
      price: PropTypes.shape({
        amount: PropTypes.number.isRequired,
        currency: PropTypes.string.isRequired,
      }),
      previewSet: PropTypes.shape({
        previews: PropTypes.arrayOf(
          PropTypes.shape({
            previewTypeId: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
          })
        ),
      }),
      productPageUrls: PropTypes.shape({
        fallbackUrl: PropTypes.string,
      }),
    })
  ),
  availableProductsLoading: PropTypes.bool,
  isLarge: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  listManager: listManagerShape,
  locale: PropTypes.string,
  openLoginSignupModal: PropTypes.func,
};

AvailableProductsSection.defaultProps = {
  availableProducts: [],
  availableProductsLoading: true,
  isLarge: true,
  isLoggedIn: false,
  listManager: null,
  locale: "en",
  openLoginSignupModal: () => {},
};

export default AvailableProductsSection;
